import MarketFinancialInfoCard from './MarketFinancialInfoCardContainer';

export default MarketFinancialInfoCard;
